import { useState } from 'react';

const FireproofingFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is fireproofing and why is it required in El Paso?',
      answer: 'Fireproofing is the application of fire-resistant materials to structural elements to prevent or delay structural failure during a fire. In El Paso, fireproofing is required by building codes for commercial and industrial buildings to protect structural steel, maintain building integrity during fires, allow safe evacuation time, and prevent fire spread. The International Building Code (IBC) mandates specific fire ratings based on building type, occupancy, and height.'
    },
    {
      question: 'How much does commercial fireproofing cost in El Paso?',
      answer: 'Commercial fireproofing costs in El Paso typically range from $2-$8 per square foot depending on the system type and fire rating required. Spray-applied fireproofing is most economical at $2-$4 per square foot, intumescent coatings range $5-$8 per square foot, and fire-rated assemblies vary by design. Total project costs depend on building size, fire rating requirements, accessibility, and project complexity. Most commercial projects range from $15,000 to $150,000+.'
    },
    {
      question: 'What are the different types of fireproofing systems?',
      answer: 'Common fireproofing systems include spray-applied fire-resistive materials (SFRM) which are cementitious or fiber-based coatings for structural steel, intumescent coatings which are thin-film paints that expand when heated, fire-rated gypsum board assemblies for walls and ceilings, firestop systems for sealing penetrations and joints, concrete encasement for maximum protection, and mineral fiber boards for thermal and fire protection. Each system has specific applications and fire rating capabilities.'
    },
    {
      question: 'How long does fireproofing installation take?',
      answer: 'Fireproofing installation timelines vary significantly based on project size and complexity. A typical 10,000 square foot commercial building may take 1-2 weeks for spray fireproofing, 2-3 weeks for intumescent coating application, or 3-4 weeks for comprehensive fire-rated assemblies. Factors affecting timeline include building size, fire rating requirements, accessibility, weather conditions for exterior work, and coordination with other trades. Large industrial projects may take several months.'
    },
    {
      question: 'Do fireproofing materials require maintenance?',
      answer: 'Yes, fireproofing materials require periodic inspection and maintenance to ensure continued fire protection. Spray-applied fireproofing should be inspected annually for damage, delamination, or missing material, with repairs made promptly. Intumescent coatings need inspection every 2-3 years and may require recoating if damaged. Firestop systems should be inspected after any building modifications. Regular maintenance ensures fire ratings remain valid and building code compliance is maintained.'
    },
    {
      question: 'Are fireproofing contractors required to be certified?',
      answer: 'Yes, reputable fireproofing contractors should hold relevant certifications and licenses. This includes a valid Texas contractor license, UL certification for specific fireproofing systems, manufacturer training and certification for products used, and OSHA safety certifications. Contractors should provide documentation of certifications and use only UL-listed fireproofing systems with proper installation procedures. Certification ensures quality workmanship and code compliance for your fire protection investment.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about fireproofing services and contractors in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-red-600 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FireproofingFAQ;
